import * as XLSX from "xlsx-color";
import * as FileSaver from "file-saver";
import { toast } from "react-toastify";
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
export const CsvDownload = (apiData, fileName) => {
  try {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(apiData);
    worksheet["A1"].s = { font: { bold: true } };
    worksheet["A2"].s = { font: { bold: true } };
    worksheet["A3"].s = { font: { bold: true } };
    const columnWidths = [
      { wch: 20 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
    ];

    worksheet["!cols"] = columnWidths;
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelBlob, fileName + fileExtension);
    toast.success(`${fileName} details exported successfully`);
  } catch (err) {
    console.log("Error in Csv Converter:", err);
    toast.error("Something Went Wrong in CSV file Download");
  }
};
